import { MouseEventHandler, useRef, useState } from 'react';

import { AssistantOutlined } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { Box } from '@mui/material';

import Button from '@/components/Buttons/Button';
import Typography from '@/components/Typography';
import ChatHistory from '@/features/AIChat/AskGXDrawer/ChatHistory';
import { useChat } from '@/features/AIChat/context/useChat';

const Header = ({ onClose }: { onClose: MouseEventHandler }) => {
  const { conversationId, setConversationId, messages } = useChat();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const historyBtnRef = useRef<HTMLDivElement | null>(null);

  const open = Boolean(anchorEl);
  const handleHistoryClick = () => {
    if (open) {
      setAnchorEl(null);
    } else if (historyBtnRef.current) {
      setAnchorEl(historyBtnRef.current);
    }
  };
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid var(--GX-Text-Disabled, #6C737A)',
        background: 'var(--GX-Main-Background, #070818)'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pl: '24px',
          pr: '32px',
          width: '100%'
        }}
      >
        <Box sx={{}}>
          <Typography
            component='div'
            sx={{
              display: 'flex',
              gap: '16px',
              alignItems: 'center',
              fontSize: '32px',
              height: '60px'
            }}
            variant='h2'
          >
            <AssistantOutlined
              sx={{
                width: '32px',
                height: '32px'
              }}
            />
            GX Go Assistant
          </Typography>
          <Typography
            component='div'
            sx={{
              color: 'var(--GX-Text-Disabled, #6C737A)',
              fontFamily: 'Cairo',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: 'normal'
            }}
          >
            Chat initialized with thread ID:{' '}
            {conversationId ?? 'There was an error. Please try again'}
          </Typography>
        </Box>
        <Button
          color='primary'
          disabled={messages.length === 0 && conversationId !== null}
          size='large'
          sx={{
            '&.Mui-disabled': {
              backgroundColor: 'var(--GX-Text-Disabled, #6C737A)',
              color: 'var(--GX-Neutral, #4F5458)',
              opacity: 1
            },
            width: '144px',
            height: '36px',
            padding: '4px 12px'
          }}
          variant='contained'
          onClick={() => {
            setConversationId('');
          }}
        >
          <AddIcon
            sx={{
              width: '24px',
              height: '24px'
            }}
          />
          New Chat
        </Button>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '2px'
        }}
      >
        <Box
          ref={historyBtnRef}
          role='button'
          sx={{
            width: 48,
            height: 130,
            backgroundColor: 'var(--GX-Tile-Dark, #0D1228)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            p: 0
          }}
          onClick={handleHistoryClick}
        >
          <HistoryOutlinedIcon />
        </Box>
        <Box
          role='button'
          sx={{
            width: 48,
            height: 130,
            backgroundColor: 'var(--GX-Tile-Dark, #0D1228)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer'
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </Box>
      </Box>
      <ChatHistory
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
      />
    </Box>
  );
};

export default Header;
